var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "share (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_2775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path888",
    d: "M0 1.90735e-06H22V22H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_2775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    d: "M12.7188 4.29688C12.7188 6.19536 14.2578 7.73438 16.1562 7.73438C18.0547 7.73438 19.5937 6.19536 19.5937 4.29688C19.5937 2.39839 18.0547 0.859376 16.1562 0.859376C14.2578 0.859376 12.7188 2.39839 12.7188 4.29688Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path898",
    d: "M2.40625 11C2.40625 12.8985 3.94526 14.4375 5.84375 14.4375C7.74224 14.4375 9.28125 12.8985 9.28125 11C9.28125 9.10151 7.74224 7.5625 5.84375 7.5625C3.94526 7.5625 2.40625 9.10151 2.40625 11Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path902",
    d: "M12.7188 17.7031C12.7188 19.6016 14.2578 21.1406 16.1562 21.1406C18.0547 21.1406 19.5937 19.6016 19.5937 17.7031C19.5937 15.8046 18.0547 14.2656 16.1562 14.2656C14.2578 14.2656 12.7188 15.8046 12.7188 17.7031Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path906",
    d: "M13.2966 6.20457L8.70508 9.09375",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path910",
    d: "M8.70508 12.9077L13.2966 15.7969",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b06c937e3a357675b9bc9c0854c67d30.svg";
export { ForwardRef as ReactComponent };